import {observer} from 'mobx-react';
import React from 'react';

import {Checkbox} from '@udemy/react-form-components';

import {CreateModalStore} from 'src/stores/create-modal-store';

import styles from './create-modal.module.less';

export const ScopeSelection = observer(
    ({createModalStore}: {createModalStore: CreateModalStore}) => {
        return (
            <>
                {createModalStore.permissions.map((permission) => (
                    <div key={permission.namespace} className={styles['scope-namespace']}>
                        <Checkbox
                            className={styles['scope-namespace-header']}
                            size="small"
                            checked={permission.checked}
                            onChange={(ev) =>
                                createModalStore.selectScopeNamespace(
                                    permission.namespace,
                                    ev.target.checked,
                                )
                            }
                        >
                            <p>{permission.namespace}</p> <span>{permission.description}</span>
                        </Checkbox>
                        <>
                            {permission.scopes.map((scope) => (
                                <Checkbox
                                    key={scope.name}
                                    className={styles['scope']}
                                    size="small"
                                    checked={scope.checked}
                                    onChange={(ev) =>
                                        createModalStore.selectScope(
                                            permission.namespace,
                                            scope.name,
                                            ev.target.checked,
                                        )
                                    }
                                >
                                    <p>{scope.name}</p> <span>{scope.description}</span>
                                </Checkbox>
                            ))}
                        </>
                    </div>
                ))}
            </>
        );
    },
);
